import {
  AP,
  FastCompany,
  Inman,
  InsideClimateNews,
  YahooFinance,
} from "@areahub/icons";

export const logos = [
  {
    href: "https://www.inman.com/2024/12/16/yonkers-housing-authority-taps-areahub-to-provide-climate-data/",
    color: "blue.400",
    desc: "Featured on Inman",
    icon: Inman,
    name: "Inman",
  },
  {
    href: "https://insideclimatenews.org/news/01102022/warming-trends-tiktok-hurricane-ian/#:~:text=Finding%20Toxic%20Elements%20in%20Your%20Neighborhood",
    color: "black",
    desc: "Featured on Inside Climate News",
    icon: InsideClimateNews,
    name: "InsideClimateNews",
  },
  {
    href: "https://apnews.com/press-release/business-wire/science-environmental-concerns-climate-and-environment-286ba1750c6342c09e407c1ae70bd3a3",
    color: "black",
    desc: "Featured on AP",
    icon: AP,
    name: "AP",
  },
  {
    color: "black",
    desc: "Featured on FastCompany",
    icon: FastCompany,
    href: "https://www.fastcompany.com/90681175/are-there-environmental-hazards-threatening-your-home-this-website-will-show-you",
    name: "FastCompany",
  },
];
